import React from "react";
import {css, useTheme} from "@emotion/react";

import {Container} from "@pg-design/grid-module";
import {backgroundColor, calculateRemSize, color, flex, flexAbsoluteCenter, flexDirection, maxWidth, mb, mr, onDesktop, p} from "@pg-design/helpers-css";
import {borderRadius} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {IExpertOpinion} from "../types/IExpertOpinion";
import {getQuarterValue} from "../utils/get_quarter_value";

interface Props {
    expertOpinion: IExpertOpinion | null;
}

export const PricesExpert = (props: Props) => {
    const {expertOpinion} = props;

    const theme = useTheme();
    const isMobile = useUserDevice();

    const date = expertOpinion?.published_at && formatDate(expertOpinion?.published_at, dateTimeFormat.quarter);

    return (
        <>
            {expertOpinion && (
                <Container css={mb(8)}>
                    <div css={sectionHolder}>
                        <div css={expertInfoStyle}>
                            <div>
                                <Image ratio={{xs: "1/1"}} css={expertImage} src={expertOpinion.img} alt={expertOpinion.name} width="360px" height="360px" />
                            </div>

                            <div css={expertTextBoxStyle}>
                                <Text as="p" variant="headline_3" align={isMobile ? "start" : "center"} css={mb(2)}>
                                    {expertOpinion.name}
                                </Text>

                                <Text variant="body_copy_1" align={isMobile ? "start" : "center"} css={[maxWidth("230px"), color(theme.colors.gray[700])]}>
                                    {expertOpinion.type}
                                </Text>
                            </div>
                        </div>

                        <div css={statementStyle}>
                            <Text variant="headline_2" css={mb(!date ? 4 : 2)}>
                                {expertOpinion.title}
                            </Text>

                            {date && (
                                <Text as="p" variant="headline_4" css={[mb(4), color(theme.colors.gray[700])]}>
                                    {`${getQuarterValue(+date.split("")[0]).concat(date.slice(1))} r.`}
                                </Text>
                            )}

                            <Text as="div" css={color(theme.colors.gray[700])}>
                                <div dangerouslySetInnerHTML={{__html: expertOpinion.text}} />
                            </Text>
                        </div>
                    </div>
                </Container>
            )}
        </>
    );
};

const sectionHolder = css`
    ${backgroundColor("#fff")};
    ${p(3)};
    ${borderRadius(2)};

    ${onDesktop(css`
        ${flex()};
        ${flexDirection("row")};
    `)};
`;

const expertInfoStyle = css`
    ${mb(4)};
    ${flex()};
    ${flexDirection("row")};

    ${onDesktop(css`
        ${flexAbsoluteCenter};
        ${flexDirection("column")};
        ${mr(4)};
        ${mb(0)};
        min-width: 20%;
    `)};
`;

const expertImage = css`
    border-radius: 50%;
    width: ${calculateRemSize(13)};
    height: ${calculateRemSize(13)};
    ${mr(3)};

    ${onDesktop(css`
        width: ${calculateRemSize(21)};
        height: ${calculateRemSize(21)};
        ${mb(4)};
        ${mr(0)};
    `)};
`;

const expertTextBoxStyle = css`
    ${flex("flex-start", "center")};
    ${flexDirection("column")};

    ${onDesktop(css`
        ${flexAbsoluteCenter};
    `)};
`;

const statementStyle = css`
    ${flex("flex-start", "center")};
    ${flexDirection("column")};
`;
import React from "react";
import {css, useTheme} from "@emotion/react";

import {Container} from "@pg-design/grid-module";
import {backgroundColor, calculateRemSize, color, flex, flexAbsoluteCenter, flexDirection, maxWidth, mb, mr, onDesktop, p} from "@pg-design/helpers-css";
import {borderRadius} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {IExpertOpinion} from "../types/IExpertOpinion";
import {getQuarterValue} from "../utils/get_quarter_value";

interface Props {
    expertOpinion: IExpertOpinion | null;
}

export const PricesExpert = (props: Props) => {
    const {expertOpinion} = props;

    const theme = useTheme();
    const isMobile = useUserDevice();

    const date = expertOpinion?.published_at && formatDate(expertOpinion?.published_at, dateTimeFormat.quarter);

    return (
        <>
            {expertOpinion && (
                <Container css={mb(8)}>
                    <div css={sectionHolder}>
                        <div css={expertInfoStyle}>
                            <div>
                                <Image ratio={{xs: "1/1"}} css={expertImage} src={expertOpinion.img} alt={expertOpinion.name} width="360px" height="360px" />
                            </div>

                            <div css={expertTextBoxStyle}>
                                <Text as="p" variant="headline_3" align={isMobile ? "start" : "center"} css={mb(2)}>
                                    {expertOpinion.name}
                                </Text>

                                <Text variant="body_copy_1" align={isMobile ? "start" : "center"} css={[maxWidth("230px"), color(theme.colors.gray[700])]}>
                                    {expertOpinion.type}
                                </Text>
                            </div>
                        </div>

                        <div css={statementStyle}>
                            <Text variant="headline_2" css={mb(!date ? 4 : 2)}>
                                {expertOpinion.title}
                            </Text>

                            {date && (
                                <Text as="p" variant="headline_4" css={[mb(4), color(theme.colors.gray[700])]}>
                                    {`${getQuarterValue(+date.split("")[0]).concat(date.slice(1))} r.`}
                                </Text>
                            )}

                            <Text as="div" css={color(theme.colors.gray[700])}>
                                <div dangerouslySetInnerHTML={{__html: expertOpinion.text}} />
                            </Text>
                        </div>
                    </div>
                </Container>
            )}
        </>
    );
};

const sectionHolder = css`
    ${backgroundColor("#fff")};
    ${p(3)};
    ${borderRadius(2)};

    ${onDesktop(css`
        ${flex()};
        ${flexDirection("row")};
    `)};
`;

const expertInfoStyle = css`
    ${mb(4)};
    ${flex()};
    ${flexDirection("row")};

    ${onDesktop(css`
        ${flexAbsoluteCenter};
        ${flexDirection("column")};
        ${mr(4)};
        ${mb(0)};
        min-width: 20%;
    `)};
`;

const expertImage = css`
    border-radius: 50%;
    width: ${calculateRemSize(13)};
    height: ${calculateRemSize(13)};
    ${mr(3)};

    ${onDesktop(css`
        width: ${calculateRemSize(21)};
        height: ${calculateRemSize(21)};
        ${mb(4)};
        ${mr(0)};
    `)};
`;

const expertTextBoxStyle = css`
    ${flex("flex-start", "center")};
    ${flexDirection("column")};

    ${onDesktop(css`
        ${flexAbsoluteCenter};
    `)};
`;

const statementStyle = css`
    ${flex("flex-start", "center")};
    ${flexDirection("column")};
`;
